<style lang="less" scoped>
    .expense-modal {
        .header {
            line-height: 1.46;
            .header-handler {
                color: #999;
                line-height: 1.46;
                float: right;
                padding-right: 22px;
                .header-icon {
                    transition: .2s;
                    cursor: pointer;
                    &:hover {
                        color: #444;
                    }
                }
                .header-icon-down {
                    transform: rotate(180deg);
                }
            }
        }
        /deep/ .ivu-modal-content-drag {
            top: 30px;
            /*left: calc(100vw - 330px);*/
            left: 10px;
        }
        /deep/ .ivu-modal-body {
            transition: 0.5s;
            max-height: none;
            height: 50vh;
            word-break: break-word;
        }
        /deep/ .ivu-modal-header {
            position: relative;
            &:before {
                content: '';
                display: inline-block;
                width: 36px;
                height: 3px;
                position: absolute;
                top: 5px;
                left: 50%;
                transform: translateX(-50%);
                background-color: #CCCCCC;
                border-radius: 5px;
            }
        }
        /deep/ .primary {
            background-color: #1976d2 !important;
            border-color: #1976d2 !important;
        }
         /deep/.v-btn--disabled {
            pointer-events: none;
            color: rgba(0,0,0,.26)!important;
        }
        /deep/.primary--text {
            color: #1976d2 !important;
        }
        .expense-group {
            padding-top: 10px;
        }
        .line {
            margin: 2px 0;
        }
        .title{
            font-weight: bold;
        }
    }
    .expense-model-minimize {
        /deep/ .ivu-modal-body {
            height: 200px;
        }
    }
</style>
<template>
  <div>
    <Modal
      v-model="modal"
      class="expense-modal"
      width="800"
      draggable
      :mask="false"
      footer-hide
      :styles="{position: 'absolute', top: 0, left: 0}"
      @on-cancel="modal=false"
    >
      <div
        slot="header"
        class="header"
      >
        <span class="text-bold">批量操作</span>
        <!-- <div class="header-handler">
          <span>
            <v-btn
              style="margin-right:2px"
              small
              color="primary"
              dark
              @click="clear"
            >
              清空列表
            </v-btn>
          </span>
        </div> -->
      </div>
      <div>
        <div v-if="!!my_value.ads_record_ids.length">
          <p>
            <span class="title"> 已选投放记录</span> 
            <v-btn
              style="margin-right:2px"
              small
              color="primary"
              dark
              text
              :disabled="is_contract"
              @click="ht"
            >
              生成合同
              <span
                v-if="is_contract"
                style="color:red"
              >【已关联合同】</span>
            </v-btn>
            <v-btn
              style="margin-right:2px"
              small
              color="primary"
              dark
              text
              :disabled="is_not_same_contract_tf || is_paid_bigger_total_tf || has_no_contract_tf"
              @click="submit({
                handle_type:'fk',
                bill_type: 'ads_record_ids'
              })"
            >
              生成付款单
              <span
                v-if="has_no_contract_tf"
                style="color:red"
              >【需要关联合同】</span>
              <span
                v-if="is_not_same_contract_tf"
                style="color:red"
              >【需同一个合同】</span>
              <span
                v-if="is_paid_bigger_total_tf"
                style="color:red"
              >【付款金额需要小于预计总金额】</span>
            </v-btn>
            <v-btn
              small
              color="primary"
              dark
              text
              :disabled="is_not_same_contract_tf || is_c_bigger_total_tf || has_no_contract_tf"
              @click="submit({
                handle_type:'zd',
                bill_type: 'ads_record_ids'
              })"
            >
              生成账单
              <span
                v-if="has_no_contract_tf"
                style="color:red"
              >【需要关联合同】</span>
              <span
                v-if="is_not_same_contract_tf"
                style="color:red"
              >【需同一个合同】</span>
              <span
                v-if="is_c_bigger_total_tf"
                style="color:red"
              >【消耗金额需要小于预计总金额】</span>
              <span
                v-if="is_tf_same_not_month"
                style="color:red"
              >【发布时间需要在同一个月】</span>
            </v-btn>
            <v-btn
              v-if="isFin"
              small
              color="primary"
              dark
              text
              :disabled="is_c_bigger_total_tf "
              @click="submit({
                handle_type:'ytd',
                bill_type: 'ads_record_ids'
              })"
            >
              生成预提单
              <span
                v-if="is_tf_same_not_month"
                style="color:red"
              >【发布时间需要在同一个月】</span>
            </v-btn>
            <v-btn
              small
              color="primary"
              dark
              text
              @click="exportE"
            >
              导出Excel
            </v-btn>
          </p>
          <div>
            <v-chip
              v-for="item in my_value.ads_record_ids"
              :key="item.id"
              close
              color="primary"
              outlined
              style="margin: 5px;height:auto"
              @click:close="closeItem(item,'ads_record_ids')"
            >
              <div style="display:flex;padding:5px 0;align-items: center;">
                <div style="margin: 0 5px">
                  {{ item.uid }}
                </div>
                <div>
                  <p
                    v-if="item.placing_ads_contract"
                    style="color:red"
                  >
                    [合同：{{ item.placing_ads_contract.contract_uid }}]
                  </p>
                  <p
                    v-if="showTFpt(item) && is_paid_bigger_total_tf"
                    style="color:red"
                  >
                    [付款进度大于等于预计投放金额]
                  </p>
                  <p
                    v-if="showTFct(item) && is_c_bigger_total_tf"
                    style="color:red"
                  >
                    [消耗进度大于等于预计投放金额]
                  </p>
                  <p
                    v-if="is_tf_same_not_month"
                    style="color:red"
                  >
                    [发布时间：{{ item.publish_at }}]
                  </p>
                </div>
              </div>
            </v-chip>
          </div>
        </div>
        <div v-if="!!my_value.ads_vas_record_ids.length">
          <p>
            <span class="title"> 已选加成服务</span>   <v-btn
              style="margin-right:2px"
              small
              color="primary"
              dark
              text
              :disabled="is_not_same_contract_jc"
              @click="submit({
                handle_type:'fk',
                bill_type: 'ads_vas_record_ids'
              })"
            >
              生成付款单
              <span
                v-if="is_not_same_contract_jc"
                style="color:red"
              >【需同一个合同】</span>
            </v-btn>
            <v-btn
              small
              color="primary"
              dark
              text
              :disabled="is_not_same_contract_jc"
              @click="submit({
                handle_type:'zd',
                bill_type: 'ads_vas_record_ids'
              })"
            >
              生成账单
              <span
                v-if="is_not_same_contract_jc"
                style="color:red"
              >【需同一个合同】</span>
              <span
                v-if="is_jc_same_not_month"
                style="color:red"
              >【服务时间需要在同一个月】</span>
            </v-btn>
          </p>
          <div>
            <v-chip
              v-for="item in my_value.ads_vas_record_ids"
              :key="item.id"
              close
              color="primary"
              outlined
              style="margin: 5px;height:auto"
              @click:close="closeItem(item,'ads_vas_record_ids')"
            >
              <div style="display:flex;padding:5px 0;align-items: center;">
                <div style="margin: 0 5px">
                  {{ item.uid }}
                </div>  
                <div>
                  <p
                    v-if="item.placing_ads_contract&&is_not_same_contract_jc"
                    style="color:red"
                  >
                    [合同：{{ item.placing_ads_contract.contract_uid }}]
                  </p>
                  <p
                    v-if="is_jc_same_not_month"
                    style="color:red"
                  >
                    [服务时间：{{ item.service_date }}]
                  </p>
                </div>
              </div>
            </v-chip>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {placing_ads_record_export} from '../service'
  export default {
    props:{
      value: {
        type: Object,
      },
      show: {
        type: Boolean,
        default:() => false
      },
      isFin: {
        type: Boolean,
        default:() => false
      }
    },
    data() {
      this.value_source = null
      return {
        modal: false,
        my_value: this.value,
      }
    },
    computed: {
      is_jc_same_not_month() {
        let res = false
        let current = null
        const ads_vas_record_ids = this.my_value && this.my_value.ads_vas_record_ids || []
        ads_vas_record_ids.forEach(i => {
          if (!current) {
            current = moment(i.service_date).format('YYYY-MM')
            return 
          }
          if (current !== moment(i.service_date).format('YYYY-MM')) {
            res = true
          }
        })
        return res
        // service_date
      },
      is_tf_same_not_month() {
        let res = false
        let current = null
        const ads_record_ids = this.my_value && this.my_value.ads_record_ids || []
        ads_record_ids.forEach(i => {
          if (!current) {
            current = moment(i.publish_at).format('YYYY-MM')
            return 
          }
          if (current !== moment(i.publish_at).format('YYYY-MM')) {
            res = true
          }
        })
        return res
      },
      is_c_bigger_total_tf() {
        const ads_record_ids = this.my_value && this.my_value.ads_record_ids || []
        return ads_record_ids.some(this.showTFct)
      },
      is_paid_bigger_total_tf() {
        const ads_record_ids = this.my_value && this.my_value.ads_record_ids || []
        return ads_record_ids.some(this.showTFpt)
      },
      is_not_same_contract_jc() {
        const arr = this.my_value && this.my_value.ads_vas_record_ids || []
        let can = false
        let stand = null
        arr.forEach((d, index) => {
          const contract = d.placing_ads_contract
          if (index === 0) {
            stand = contract
            return 
          }
          const is_go = (!stand && !!contract) || // 有或没有
            (!!stand && !contract) || // 同上
            (!!stand && !!contract && contract.contract_id !== stand.contract_id) // id不同
          if (is_go) {
            can = true
          }
        });

        return can
      },
      has_no_contract_tf() {
        const ads_record_ids = this.my_value && this.my_value.ads_record_ids || []
        return ads_record_ids.some(i => !i.placing_ads_contract)
      },
      is_not_same_contract_tf() {
        const ads_record_ids = this.my_value && this.my_value.ads_record_ids || []
        let can = false
        let stand = null
        ads_record_ids.forEach((d, index) => {
          const contract = d.placing_ads_contract
          if (index === 0) {
            stand = contract
            return 
          }
          const is_go = (!stand && !!contract) || // 有或没有
            (!!stand && !contract) || // 同上
            (!!stand && !!contract && contract.contract_id !== stand.contract_id) // id不同
          if (is_go) {
            can = true
          }
        });

        return can
      },
      is_contract() {
        return this.my_value && this.my_value.ads_record_ids.some(i => !!i.placing_ads_contract)
      }
    },
    watch: {
      my_value(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.my_value = val
      },
      show(value) {
        this.modal = value
      },
      modal(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    },
    methods: {
      showTFpt(item) {
        const go_1 = Number(item.paid_price) === Number(item.total_price) && Number(item.paid_price) === 0
        const go_2 = Number(item.paid_price) < Number(item.total_price)
        return !(go_1 || go_2)
      },
      showTFct(item) {
        const go_1 = Number(item.consume_price) === Number(item.total_price) && Number(item.consume_price) === 0
        const go_2 = Number(item.consume_price) < Number(item.total_price)
        return !(go_1 || go_2)
      },
      cx() {
        return this.value_source 
      },
      ht() {
        this.value_source = this.my_value
        this.modal = false
        this.submit({
          handle_type:'ht',
          target: this.my_value
        })
      },
      exportE() {
        const str = this.my_value.ads_record_ids.map(i => i.id).join(',')
        window.open(`/api/${placing_ads_record_export}?record_ids=${str}`, '__blank')
      },
      submit(params) {
        this.$emit('submit', params)
      },
      clear() {
        this.my_value = {
          ads_record_ids: [],
          ads_vas_record_ids: [],
        }
      },
      closeItem(item, key) {
     
        this.my_value[key].forEach((i, index) => {
          if (item.id === i.id) {
            this.my_value[key].splice(index, 1)
          }
        })
      },

    }
  }
</script>
